import { AppCountry, AppStateCountry } from '../app.models';
import countryData from './countries.json';

export const config: AppCountry[] = [...countryData.countries] as AppCountry[];

export const COUNTRY_ICONS: { code: string; path: string }[] = [];

export function getCountryConfig(code: string = 'USA'): AppCountry {
  return config.find((country) => country.code === code.toUpperCase())!;
}

export function getStateConfig(
  countryCodeOrCountry: string | AppCountry,
  stateCode: string
): AppStateCountry | undefined {
  return typeof countryCodeOrCountry === 'string'
    ? getCountryConfig(countryCodeOrCountry).states?.find(
        (state) => state.code === stateCode
      )
    : countryCodeOrCountry.states?.find((state) => state.code === stateCode);
}

export function getCountryConfig2(iso2Code: string = 'US'): AppCountry {
  return config.find((country) => country.iso2Code === iso2Code)!;
}

export function getCountryPostalCodePattern(iso2Code: string) {
  return config.find((country) => country.iso2Code === iso2Code)
    ?.postalCodePattern;
}
